export default __webpack_public_path__ + "static/resource-block_words-matter-46121b16b1dd0572f2e16baf2a607feb.jpg";